import { createContext, useContext } from "react";
import type { FormConfig } from "../types/form";

interface PrefillContextType {
  prefillValues: {
    simpleFields: Record<string, any>;
    dynamicFields: Record<string, any>;
  };
  config?: FormConfig;
}

export const PrefillContext = createContext<PrefillContextType>({
  prefillValues: {
    simpleFields: {},
    dynamicFields: {},
  },
});

export const usePrefillContext = (): PrefillContextType => {
  return useContext(PrefillContext);
};
